import { sendAnalytics } from 'shared/utils/analytics';

export const trackAllOffersButtonClick = () => sendAnalytics({ action: 'all_offers', label: 'history_offers' });
